import type React from "react";
import { ReactComponent as Svg } from "./assets/terms.svg";
import * as styles from "./Icon.module.scss";

type TermsProps = React.SVGProps<SVGSVGElement>;

export const Terms = ({ className, ...props }: TermsProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
